module.exports = __webpack_public_path__ + "img/tp.d9048c6f.png";